import { connect } from 'react-redux';
import { isCancel } from 'axios';
import AddUserDialog from './AddUserDialog';
import { addUsersAsEducatorToSpace } from '../../../../../../../core/actions/classRoom/participants';
import {
  currentClassRoomId,
  participants as participantsSelector,
  isAddingParticipantToSpace,
  hasAddParticipantError,
} from '../../../../../../../core/selectors/classroom';
import { usersSearch } from '../../../../../../../core/api/search';

const searchUsers = async ({
  query,
  participants,
  selectedUsers,
  sessionToken,
}) => {
  let results;
  try {
    results = await usersSearch({
      query,
      sessionToken,
      includeEducatorInSpaces: true,
      size: 100,
    });
  } catch (e) {
    if (isCancel(e)) {
      return [];
    }
  }

  const getRelevantUsers = (finalUsers, user) => {
    const compareUserId = ({ id }) => id === user.id;
    const isParticipant = participants.find(compareUserId);
    if (isParticipant) {
      return finalUsers;
    }
    const hasBeenSelected = selectedUsers.find(compareUserId);
    if (hasBeenSelected) {
      return finalUsers;
    }

    return [
      ...finalUsers,
      {
        ...user,
        fullName: `${user.firstName} ${user.lastName}`,
      },
    ];
  };

  return results.reduce(getRelevantUsers, []);
};

const mapStateToProps = (state) => {
  const { sessionToken } = state.user.user;
  const spaceId = currentClassRoomId(state);
  let participants = [];
  if (spaceId) {
    participants = participantsSelector(state, spaceId);
  }
  return {
    participants,
    sessionToken,
    searchUsers: (query, selectedUsers, currentParticipants) =>
      searchUsers({
        query,
        participants: currentParticipants,
        selectedUsers,
        sessionToken,
      }),
    isAddingParticipantToSpace: isAddingParticipantToSpace(state),
    hasAddParticipantError: hasAddParticipantError(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  addUsersAsEducatorToSpace: (userIds) =>
    dispatch(addUsersAsEducatorToSpace(userIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUserDialog);
